import "core-js/modules/es.object.assign.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { swiper, swiperSlide } from 'vue-awesome-swiper';
import Drip from 'drip';
require('swiper/dist/css/swiper.css');
export default {
  name: 'ad-banner',
  data: function data() {
    return {
      swiperOption: null
    };
  },
  components: {
    swiper: swiper,
    swiperSlide: swiperSlide
  },
  props: {
    bannerList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  watch: {
    bannerList: 'initSwiper'
  },
  created: function created() {
    var _this$bannerList;
    this.initSwiper();
    if (((_this$bannerList = this.bannerList) === null || _this$bannerList === void 0 ? void 0 : _this$bannerList.length) === 1) {
      this.seedExposure(0);
    }
  },
  methods: {
    initSwiper: function initSwiper() {
      var _this = this;
      var that = this;
      this.swiperOption = {
        autoplay: 5000,
        pagination: '.swiper-pagination',
        initialSlide: 0,
        slidesPerView: 1,
        paginationClickable: true,
        autoplayDisableOnInteraction: false,
        loop: this.bannerList.length > 1,
        loopAdditionalSlides: this.bannerList.length,
        paginationBulletRender: function paginationBulletRender(swiper, index, className) {
          return that.bannerList.length > 1 ? "<span class=\"".concat(className, " swiper-pagination-bullet-custom\"></span>") : '';
        },
        onSlideChangeEnd: function onSlideChangeEnd(_ref) {
          var realIndex = _ref.realIndex;
          _this.seedExposure(realIndex);
        }
      };
    },
    seedExposure: function seedExposure() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var _ref2 = this.bannerList[index] || {},
        dataSeed = _ref2.dataSeed;
      if (!(dataSeed && dataSeed.viewBid)) return;
      window.seedAction(Object.assign({
        evt: 'view'
      }, dataSeed, {
        bid: dataSeed.viewBid
      }));
    },
    slideClicked: function slideClicked(e) {
      var _ref3 = e.target.dataset || {},
        index = _ref3.index;
      var item = this.bannerList[index];
      if (!item) return;
      var jumpUrl = item.jumpUrl,
        dataSeed = item.dataSeed;
      Drip.redirect(jumpUrl, {
        _blank: true
      });
      if (dataSeed) {
        window.seedAction(Object.assign({
          evt: 'click'
        }, dataSeed, {
          bid: dataSeed.bid,
          needTag: true
        }));
      }
    }
  }
};